import type { UnresolvedQuestionItem } from '@/types/requirements_quality'
import { QuestionGroup } from '../components/QuestionGroup'

interface Props {
  questions: UnresolvedQuestionItem[]
}

const QUESTION_SOURCE_LABEL: Record<string, { label: string, color: string }> = {
  validation: { label: 'モデル検証', color: 'var(--bp-warning)' },
  domain_pattern: { label: '業界慣行に基づく論点', color: 'var(--bp-info)' },
  terminology_gap: { label: '用語ズレ', color: 'var(--bp-accent)' },
  exception_path: { label: '例外経路', color: 'var(--bp-warning)' },
  consistency: { label: '整合性', color: 'var(--bp-critical)' },
  permission_matrix: { label: '権限', color: 'var(--bp-warning)' },
  state_transition: { label: '状態遷移', color: 'var(--bp-warning)' },
  feature_gap: { label: '機能', color: 'var(--bp-warning)' }
}

const QUESTION_SOURCE_ORDER = Object.keys(QUESTION_SOURCE_LABEL)

export function QuestionsTab ({ questions }: Props): React.ReactElement {
  if (questions.length === 0) {
    return (
      <div style={{ textAlign: 'center', padding: '60px 0', color: 'var(--bp-ink3)', fontSize: 13 }}>
        確認ポイントはありません
      </div>
    )
  }

  const groups = QUESTION_SOURCE_ORDER
    .map((source) => ({
      source,
      sourceInfo: QUESTION_SOURCE_LABEL[source] ?? { label: source, color: 'var(--bp-ink3)' },
      items: questions.filter((q) => q.source === source)
    }))
    .filter((g) => g.items.length > 0)

  return (
    <div>
      <div className='section-head'>
        <h3>確認ポイント一覧</h3>
        <span className='count'>要件定義で確認しておきたい論点 {questions.length}件</span>
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
        {groups.map((g) => (
          <QuestionGroup
            key={g.source}
            sourceInfo={g.sourceInfo}
            items={g.items}
            defaultOpen={false}
          />
        ))}
      </div>
    </div>
  )
}
